import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import './Banner.css';
import { HashLink } from 'react-router-hash-link';
import Type from '../Type/Type';
import { motion } from 'framer-motion';

const Banner = () => {
  const [showTyper, setShowTyper] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setShowTyper(true);
    }, 1200);
  }, []);
  return (
    <div className='banner-container'>
      <motion.div className='container centered'>
        <motion.h1
          className=' text-center pt-5'
          initial={{ x: '100vw' }}
          animate={{ x: '0' }}
          transition={{
            delay: '0.7',
            type: 'spring',
            stiffness: 110,
          }}
        >
          <motion.h1 className='fw-bolder text-center text-white'>
            Hi, my name is Tanvir Ahmed
          </motion.h1>
          <span className='wave' role='img' aria-labelledby='wave'>
            👋🏻
          </span>
        </motion.h1>
        {/* <h1 className="fw-bolder text-center text-white pt-2">Tanvir Ahmed</h1> */}
        <motion.h3
          className='text-center text-white mt-3'
          initial={{ x: '100vw' }}
          animate={{ x: '0' }}
          transition={{
            delay: '0.7',
            type: 'spring',
            stiffness: 110,
          }}
        >
          I'm the Front-End Developer 🚀 you need!
        </motion.h3>
        <h2
          style={{
            padding: '25px',
            textAlign: 'center',
            color: 'white',
            fontWeight: 'bold',
          }}
          className={`${showTyper ? 'visible' : 'invisible'}`}
        >
          <Type />
        </h2>

        <motion.div
          initial={{ x: '-100vw' }}
          animate={{ x: '0' }}
          transition={{
            delay: '1.5',
            type: 'spring',
            stiffness: 110,
          }}
        >
          {' '}
          <HashLink to='/home#topProjects'>
            <Button
              variant='info'
              size='lg'
              className='mt-4 text-white fw-bold'
            >
              READ MORE
            </Button>
          </HashLink>
          <Button
            variant='danger'
            size='lg'
            className='mt-4 text-white fw-bold ms-3'
            onClick={() =>
              window.open(
                'https://drive.google.com/file/d/1yh-OjZdF-qprbfEEr64WC6RNQiFYIOCI/view',
                '_blank'
              )
            }
          >
            Download Resume
          </Button>
        </motion.div>

        <br />
      </motion.div>
    </div>
  );
};

export default Banner;
